import { useEffect, useState } from "react";
import { Activity, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";

const tone = { ok: "bg-emerald-50 text-emerald-700 border-emerald-200", warning: "bg-amber-50 text-amber-800 border-amber-200", critical: "bg-red-50 text-red-700 border-red-200" };

export const HealthPanel = () => {
  const [h, setH] = useState(null);
  const [err, setErr] = useState(null);
  const load = () => api.get("/system/health").then((r) => { setH(r.data); setErr(null); }).catch((e) => setErr(e.message));
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  return (
    <div className="doc-card p-4 mb-8" data-testid="health-panel">
      <div className="flex flex-wrap gap-2 items-center justify-between mb-3">
        <p className="eyebrow flex items-center gap-1.5"><Activity size={13} /> Production health {h && <span data-testid="health-overall" className={`pill !py-0 ${tone[h.overall]}`}>{h.overall}</span>}</p>
        <button className="text-[11px] text-slate-500 hover:text-slate-800 flex items-center gap-1" onClick={load} data-testid="health-refresh-button"><RefreshCw size={11} /> refresh</button>
      </div>
      {err && <p className="text-xs text-red-600" data-testid="health-error">{err}</p>}
      {!h && !err && <p className="text-xs text-slate-500">probing…</p>}
      {h && <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {h.probes.map((p) => <div key={p.id} className={`rounded-md border px-3 py-2 ${tone[p.level]}`} data-testid={`health-probe-${p.id}`} title={p.label}>
          <p className="text-[11px] uppercase tracking-wide opacity-80">{p.label}</p>
          <p className="text-xs mt-0.5 break-words">{p.value}</p>
          {p.apps?.length > 0 && <ul className="mt-1 space-y-0.5">{p.apps.map((a) => <li key={a.url} className="text-[11px]"><a className="underline" href={a.url} target="_blank" rel="noreferrer">{a.project}</a> v{a.version} — {a.ok === false ? "DOWN" : a.ok ? "up" : "unprobed"}</li>)}</ul>}
        </div>)}
      </div>}
      {h && <p className="text-[10px] text-slate-400 mt-2">checked {new Date(h.checked_at).toLocaleTimeString()} · warn/critical: disk {h.thresholds.disk_pct.join("/")}%, memory {h.thresholds.mem_pct.join("/")}%, TLS {h.thresholds.tls_days.join("/")} days, backup age {h.thresholds.backup_age_h.join("/")} h</p>}
    </div>
  );
};
